module.exports = __webpack_public_path__ + "static/media/small-street-selected.79883d5b.svg";